var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "12px",
    viewBox: "0 0 18 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FOOTER",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UPDATE-Footer-desk",
    transform: "translate(-512.000000, -203.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape-3",
    transform: "translate(512.000000, 203.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.9285113,0 C0.871117101,0 0,0.841266518 0,1.86201801 L0,10.137982 C0,11.1587704 0.871308429,12 1.9285113,12 L16.0714887,12 C17.1288829,12 18,11.1587335 18,10.137982 L18,1.86201801 C18,0.841229572 17.1286916,0 16.0714887,0 L1.9285113,0 Z M2.06912984,1.24146849 L15.9377809,1.24146849 L9.39512326,6.87946896 C9.14565047,7.09450732 8.86835857,7.09465141 8.61829267,6.87946896 L2.06912984,1.24109903 L2.06912984,1.24146849 Z M1.28560277,2.23063092 L5.69189024,6.02575155 L1.28560277,10.1120088 L1.28560277,2.23063092 Z M16.7143054,2.23063092 L16.7143054,10.1057279 L12.3214109,6.01947068 L16.7143054,2.23063092 Z M11.357117,6.85334795 L15.5560047,10.7585685 L2.44428609,10.7585685 L6.65618415,6.85999828 L7.76110426,7.81051491 C8.46346993,8.41521447 9.54971641,8.41610118 10.2522734,7.81051491 L11.3573466,6.85353268 L11.357117,6.85334795 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterMail);
export default __webpack_public_path__ + "static/media/footer-mail.9902009f49bb258de470a533e2c8283a.svg";
export { ForwardRef as ReactComponent };